import Widget from 'components/widget/Widget';
import { useVideoTokensStore } from 'views/store/useVideoTokensStore';
import VideoTokensTable from './components/VideoTokensTable';
import { MdVideoLibrary } from 'react-icons/md';

const VideoTokens = () => {
  const { totalTokens } = useVideoTokensStore();

  return (
    <div>
      <div className="mt-3 w-full flex md:flex-row gap-4 items-center">
        <div className="w-fit">
          <Widget
            icon={<MdVideoLibrary className="h-7 w-7" />}
            title="Total video tokens"
            subtitle={!totalTokens ? 'Loading...' : totalTokens}
          />
        </div>
      </div>
      <div className="mt-5 grid grid-cols-1 gap-5">
        <div className="w-full">
          <VideoTokensTable />
        </div>
      </div>
    </div>
  );
};

export default VideoTokens;
